export default __webpack_public_path__ + "static/media/higher_primary_logo_tagline.7598fd73.svg";